import React, { Component } from 'react';



export class Home extends Component {
    static displayName = Home.name;

  render () {

    return (
        <div>
        <p>Welcome to the NFL2k5 Resource Page </p>
        <p>Created by Seskid</p>
     
        </div>
        );
    }
}
  